<template>
  <div>
    <aside :class="{ open: isOpen }">
      <ul>
        <li v-for="(navItem, index) in navItems" :key="index" :class="[ { current: activeNavItem == navItem['href']}, navItem['class'] ]" :id="navItem['id']">
          <a :href="navItem['href']">
            {{ navItem['label'] }}
          </a>
        </li>
      </ul>
    </aside>
    
    <div id="navbar-toggler" @click="toggleMenu" aria-controls="navbarToggler" aria-expanded="false" aria-label="Toggle side navigation" :class="{ open: isOpen }">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
  
</template>

<script>
export default {
  props: {
    navItems: { type: Array, required: true },
    activeNavItem: { type: String, required: false, default: '/' }
  },

  data() {
    return {
      isOpen: false
    }
  },

  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen
      EventDispatcher.fire('toggleSidebarMenu', this.isOpen);
    }
  },
}
</script>

<style lang="scss" scoped>
  #navbar-toggler {
    display:block !important;
    width:20px;
    height:18px;
    margin:.375rem 0 0 1.25rem;
    padding:0;
    cursor:pointer;
    z-index:3000;
    color:transparent;
    -webkit-transform: rotate(0deg); 
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg); 
    transform: rotate(0deg);
    -webkit-transition: .5s ease-in-out;  
    -moz-transition: .5s ease-in-out;
    -o-transition: .5s ease-in-out; 
    transition: .5s ease-in-out;

    span { 
      display: block;
      position: absolute;
      height:2px;
      width:19px;
      background: #fff;
      opacity: 1;
      left: 0;
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
      -webkit-transition: .25s ease-in-out;
      -moz-transition: .25s ease-in-out;
      -o-transition: .25s ease-in-out;
      transition: .25s ease-in-out;
    }
  }
  
  #navbar-toggler:not(.open) span { 
    background:#000; 
  }
  
  #navbar-toggler span:nth-child(1) { 
    top: 0; 
    -webkit-transform-origin: left center; 
    -moz-transform-origin: left center;
    -o-transform-origin: left center; 
    transform-origin: left center; 
  }
  
  #navbar-toggler span:nth-child(2) { 
    top: 8px; 
    -webkit-transform-origin: left center; 
    -moz-transform-origin: left center;
    -o-transform-origin: left center; 
    transform-origin: left center; 
  }
  
  #navbar-toggler span:nth-child(3) { 
    top: 16px; 
    -webkit-transform-origin: left center; 
    -moz-transform-origin: left center;
    -o-transform-origin: left center; 
    transform-origin: left center; 
  }
  
  #navbar-toggler.open span:nth-child(1) { 
    -webkit-transform: rotate(45deg); 
    -moz-transform: rotate(45deg);
    -o-transform: rotate(45deg); 
    transform: rotate(45deg); 
    top:0; 
    left:0;
    width:21px;
  }

  #navbar-toggler.open span:nth-child(2) { 
    width: 0%; 
    opacity: 0; 
  }
  
  #navbar-toggler.open span:nth-child(3) { 
    -webkit-transform: rotate(-45deg); 
    -moz-transform: rotate(-45deg); 
    -o-transform: rotate(-45deg);
    transform: rotate(-45deg); 
    top: 15px; 
    left:0; 
    width:21px;  
  }

  aside {
    position:fixed;
    top:0;
    bottom:0;
    box-shadow: 0 0 .5rem 0 rgba(0, 0, 0, 0.2);
    width:25%;
    min-width:240px;
    left:auto;
    right:0;
    background-color:#404040;
    opacity:0;
    display:none;
    visibility: hidden;
    -webkit-transition: opacity 600ms, visibility 600ms;
    transition: opacity 600ms, visibility 600ms;
    padding:5.5rem 0 0 4.5rem;

    &.open {
      opacity:1;
      visibility:visible;
      display:block;
      animation: fade 1s;
    }

    a {
      color:#ccc;
      font-size:1.5rem;
      display:inline-block;
      border-bottom:2px solid transparent;

      &:hover {
        border-bottom:2px solid #fff;
        color:#fff;
      }
    }

    ul {
      position:relative; 
      padding-left:0;

      li {
        list-style: none;
        position:relative;

        .nav-icon {
          margin: -6px 5px 0;
          height: 24px;
        }

        &.current a {
          color:#fff;
        }

        &.pages-sidenav {
          margin-left:-2.425rem;
          a { 
            font-weight:400; 
            font-size:1rem; 
          }
        }
        
      }

      #home-link-sidenav::before, #map-link-sidenav::before, 
      #locations-link-sidenav::before, #charters-link-sidenav::before {
        height: 1.5rem;
        width: 1.5rem;
        top:.25rem;
        position:absolute;
        left:-2.45rem;
      }

      #home-link-sidenav::before { content:url(/img/ico-home-w.svg); }
      #map-link-sidenav::before { content:url(/img/ico-karte-w.svg); }
      #locations-link-sidenav::before { content:url(/img/ico-orte-w.svg); }
      #charters-link-sidenav::before { content:url(/img/ico-urkunden-w.svg); }

       #charters-link-sidenav {
          margin-bottom:1.25rem;
        }
    }
    
  }
  
  @keyframes fade {
      0% {
          opacity: 0;
      }
      100% {
          opacity: 1;
      }
  }
</style>


